<template>
    <v-tooltip top>
        <a slot="activator" @click="ativarAnexo" class="az-action-link-icon">
            <i :class="classeIcone" aria-hidden="true"/>
        </a>
        <span v-if="bloquearAcao === true">Aguarde</span>
        <span v-else>Ativar</span>
    </v-tooltip>
</template>

<script>
export default {
    name: 'BotaoAtivarAnexo',
    props:{
        situacaoAtual:{
            type: String,
            default: null
        }
    },
    data(){
        return{
            bloquearAcao: false
        }
    },
    computed:{
        classeIcone(){
            const base = 'fas fa-eye'
            if(this.bloquearAcao === true){
                return base + ' ' + 'desativado'
            }
            return base
        }
    },
    methods:{
        ativarAnexo(){
            if(this.bloquearAcao === true){ return }
            this.$emit('ativarAnexo')
        },
        desabilitarTemporario(){
            this.bloquearAcao = true

            setTimeout(() => {
                this.bloquearAcao = false
            }, 10000)
        }
    },
    watch:{
        situacaoAtual:{
            handler(){
                this.desabilitarTemporario()
            }
        }
    }
}

</script>

<style scoped lang="stylus">
    @media (max-width 720px)
        .az-action-link-icon i
            font-size 20px

    .desativado
        opacity 0.5
</style>
